import { render, staticRenderFns } from "./main_dashboard.vue?vue&type=template&id=803c5336&scoped=true&"
import script from "./main_dashboard.vue?vue&type=script&lang=js&"
export * from "./main_dashboard.vue?vue&type=script&lang=js&"
import style0 from "./main_dashboard.vue?vue&type=style&index=0&id=803c5336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803c5336",
  null
  
)

export default component.exports